const Constants = {
    vectors: {
        domainX: [-30,30],
        domainY: [-30,30]
    }
}

export default Constants;